import React from "react";
import "./kyb.css";
import { useKybStatusRouting } from "./useKybStatus";
import { formatKybVerifiedAtUtc, pickKybBusinessName } from "./kybDisplayFields";

export default function KYBSuccess() {
  const { sessionPayload } = useKybStatusRouting();
  const businessName = pickKybBusinessName(sessionPayload);
  const verifiedAt = formatKybVerifiedAtUtc(sessionPayload);

  return (
    <div className="dashboard_right">
      <div className="kyc-page kyb_verification_page">
        <div className="kyb_status_container successfull">
          <div className="kyb_status_icon_wrap">
            <img src="/images/kyb-verification-img/kyb_successful.svg" alt="Success" />
          </div>

          <h2 className="kyb_status_title">
            KYB Verification <span className="success">Successful!</span>
          </h2>

          <p className="kyb_status_desc">
            Your business has been verified successfully.
          </p>

          <div className="kyb_info_card">

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/bussiness_icon.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Business Name</div>
                <div className="kyb_info_value">{businessName}</div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_verification.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verification Status</div>
                <div className="kyb_info_value success">
                  <i className="ri-check-line"></i> Verified
                </div>
              </div>
            </div>


            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_date.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verification Date</div>
                <div className="kyb_info_value">{verifiedAt}</div>
              </div>
            </div>

            <div className="kyb_info_item">
              <div className="kyb_info_icon">
                <img src="/images/kyb-verification-img/kyb_party.svg" alt="Icon" />
              </div>
              <div className="kyb_info_text">
                <div className="kyb_info_label">Verification Method</div>
                <div className="kyb_info_value">Business Verification (KYB)</div>
              </div>
            </div>

          </div>

          <div className="kyb_success_alert">
            You now have full access to all platform features and higher limits.
          </div>

          <div className="kyb_unlocked_section">
            <h3>What's Unlocked Now</h3>
            <div className="kyb_unlocked_grid">

              <div className="kyb_unlocked_card">
                <div className="kyb_unlocked_icon">
                  <img src="/images/kyb-verification-img/unlocked_icon.svg" alt="unlocked" />
                </div>
                <h4>Higher Limits</h4>
                <p>Increased deposit, withdrawal and trading limits.</p>
              </div>

              <div className="kyb_unlocked_card">
                <div className="kyb_unlocked_icon">
                  <img src="/images/kyb-verification-img/unlocked_icon2.svg" alt="unlocked" />
                </div>
                <h4>Full Platform Access</h4>
                <p>Access all products and platform features.</p>
              </div>

              <div className="kyb_unlocked_card">
                <div className="kyb_unlocked_icon">
                  <img src="/images/kyb-verification-img/unlocked_icon3.svg" alt="unlocked" />
                </div>
                <h4>Institutional Services</h4>
                <p>Get access to institutional and OTC services.</p>
              </div>

              <div className="kyb_unlocked_card">
                <div className="kyb_unlocked_icon">
                  <img src="/images/kyb-verification-img/unlocked_icon4.svg" alt="unlocked" />
                </div>
                <h4>P2P & Fiat Services</h4>
                <p>Use P2P trading and fiat on/off ramp services.</p>
              </div>

              <div className="kyb_unlocked_card">
                <div className="kyb_unlocked_icon">
                  <img src="/images/kyb-verification-img/unlocked_icon5.svg" alt="unlocked" />
                </div>
                <h4>Priority Support</h4>
                <p>Enjoy priority support for verified businesses.</p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
